<template @touchmove.prevent>
  <div id="stage">
    <h1>{{ title }}</h1>
    <el-row :gutter="24"><!-- type="flex" justify="space-between"-->
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText">
          </el-input>
          <section
            ref="treeContainer"
            class="tree-container"
          >
            <el-tree id="data-tree"
                     ref="tree"
                     draggable
                     :class="data_tree_class_list"
                     default-expand-all
                     :data="randomLine"
                     :props="defaultProps"
                     highlight-current
                     check-strictly
                     node-key="id"
                     :filter-node-method="filterNode"
                     @node-click="handleNodeClick"
                     @node-drag-start="handleDragStart"
                     :allow-drop="allowDrop"
            ></el-tree>
          </section>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <canvas :width="canvas_width" :height="canvas_height" id="canvas" ref="canvas">

          </canvas>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <el-table
            :data="tableData"
            @row-click="handleTableRowClick"
            ref="table"
            :height="tableHeight"
            style="width: 100%">
            <el-table-column
              prop="fieldName"
              label="字段名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="fieldDesc"
              label="字段描述"
              width="180">
            </el-table-column>
            <el-table-column
              prop="fieldType"
              label="字段类型"
              width="100">
            </el-table-column>
            <el-table-column
              prop="required"
              label="是否必填">
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-upload
                  id="upload"
                  :class="upload_class_list"
                  drag
                  name="drag-data"
                  action=""
                  :before-upload="dragComplete">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传json或tb文件，且不超过10Mb</div>
                </el-upload>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="file-check-state">
                <el-checkbox v-model="data_checked">数据文件(*)</el-checkbox>
              </div>
              <div class="file-check-state">
                <el-checkbox v-model="table_checked">表结构(*.tb)</el-checkbox>
              </div>
              <div class="file-check-state">
                <el-checkbox v-model="mapper_checked">映射文件(*.mp)</el-checkbox>
              </div>
              <div class="file-check-state">
                <el-button type="success" @click="generateMapper">生成映射</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>删除 <span style="color:red;">{{ selectFieldName }}</span> 字段上的映射?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureRemoveMap">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="映射信息" :visible.sync="dialogMapperVisible">
      <el-input
        type="textarea"
        autosize
        v-model="mapperInfoStr">
      </el-input>
    </el-dialog>

  </div>
</template>

<script>
import {MapperDraw} from "../../../static/js/mapper-draw.js"

export default {
  name: 'mapper',
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  data() {
    return {
      title: '数据映射在线编辑',
      data_checked: false,
      table_checked: false,
      mapper_checked: false,
      dialogMapperVisible: false,
      filterText: '',
      dialogVisible: false,
      selectFieldName: '',
      selectMapperIndex: -1,
      keyIndex: 0,
      upload_class_list: [],
      data_tree_class_list: ['data-tree', 'not-select'],
      randomLine: [{}],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      bottomPadding: 50,// 底部内边距
      tableHeight: "600px",
      tableData: [],
      uploadData: '',
      dragNode: {},//缓存被拖动的节点
      cas: null, //Canvas
      ctx: null, //画布Context
      canvas_width: "",
      canvas_height: "",
      draw: {}, //渲染器
      mapperInfo: [],
      mapperInfoStr: ''//MapperInfo 序列化
    }
  },
  methods: {
    checkChange(data, check) {
      let chooseNode = this.$refs.tree.getNode(data.id)
      if (check) {
        //如果节点被选中 则添加到表中
        if (!chooseNode) return
        this.tableData.push({
          id: data.id,
          fieldName: chooseNode.isLeaf ? data.label.split(":")[0] : data.label,
          fieldDesc: '',
          required: true
        })
      } else {
        //如果取消, 则删除右侧表结构
        this.tableData.findIndex(val => val.id === data.id) >= 0 && this.tableData.splice(target, 1)
      }
    },
    handleNodeClick(data) {
      //单机树节点
    },
    generateMapper() {
      //生成映射
      if (this.mapperInfo.length == 0) {
        this.$message({
          message: '请先建立至少一个映射',
          type: 'warning'
        });
        return
      }
      /**
       * - source-expression: ""
       target-key: 'id'
       */
      this.mapperInfoStr = this.mapperInfo.map(map => {
        return `- source-expression: "${map.aEnd.jsonPath}"\n  target-key: "${this.transFieldName(map.zEnd.fieldName)}"`
      }).join("\n")
      this.dialogMapperVisible = true
    },
    transFieldName(fieldName) {
      let fa = fieldName.trim().split("_")
      console.log(fa)
      let finallyName = "";
      for (let i = 0; i < fa.length; i++) {
        fa[i] = fa[i].trim().toLowerCase()
        if (!fa[i]) continue
        if (i == 0) {
          finallyName = finallyName.concat(fa[i])
        } else {
          finallyName = finallyName.concat(fa[i][0].toUpperCase()).concat(fa[i].substr(1))
        }
      }
      return finallyName
    },
    handleTableRowClick(row, column, event) {
      //点击table
      let fieldName = row.fieldName
      let index = this.mapperInfo.findIndex(item => item.zEnd.fieldName == fieldName)
      console.log("请求确认")
      if (index >= 0) {
        this.selectFieldName = this.mapperInfo[index].zEnd.fieldName
        this.selectMapperIndex = index
        this.dialogVisible = true
      }
    },
    sureRemoveMap() {
      //确认删除映射
      this.dialogVisible = false
      let node = this.mapperInfo.splice(this.selectMapperIndex, 1)[0]
      //刷新渲染
      node.aEnd.dom.classList.remove("active")
      node.zEnd.dom.classList.remove("field-active")
      this.drawer.draw()
    },
    handleDragStart(node, e) {
      //开始拖拽树节点, 准备传递数据
      this.dragNode = e.target
      //计算jsonPath, 节点Y轴坐标, 节点id
      let transData = {
        jsonPath: node.data.jsonPath,
        y: e.target.offsetTop + e.target.clientHeight / 2,// 节点相对容器的Y轴偏移
        id: node.data.id // 节点ID
      }
      e.dataTransfer.setData("object", JSON.stringify(transData))
    },
    allowDrop() {
      return false
    },
    filterNode(value, data, node) {
      if (!value) return true
      return node.label.indexOf(value) >= 0
    },
    dragComplete(file) {
      let readPromise = new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = function () {
          return resolve({fileName: file.name, data: this.result})
        }
        reader.onerror = function () {
          return reject(file)
        }
        reader.readAsText(file)
      })
      readPromise.then((result) => {
        let {fileName, data} = result

        //更新文件上传状态
        if (fileName.endsWith("tb")) {
          this.table_checked = true
        } else if (fileName.endsWith("mp")) {
          this.mapper_checked = true
        } else {
          this.data_checked = true
        }

        if (fileName.endsWith("tb")) {
          //表结构
          if (!data) {
            this.$message({
              message: '表结构数据格式错误',
              type: 'warning'
            });
            return
          }
          //字段数组
          let fieldArray = data.split("\n")
          this.tableData = fieldArray.map(fieldLine => {
            let fieldItem = fieldLine.trim().split(/\s/)
            return {
              fieldName: fieldItem[0],
              fieldType: fieldItem[1],
              fieldDesc: fieldItem[2],
              required: fieldItem[3]
            }
          })
        } else {
          this.uploadData = data
          //取一行数据 渲染到dom
          let line = this.chooseLine()
          this.randomLine = this.convertToTreeNode(JSON.parse(line))
        }

      }).then(() => {
        //初始化canvas
        this.initCanvas()
      })
      return false
    },
    chooseLine() {
      //随机选择一行
      if (!this.uploadData) {
        return ''
      }
      let beginIndex, endIndex
      do {
        let searchBeginIndex = parseInt(0.2 * this.uploadData.length)
        beginIndex = this.uploadData.indexOf("\n", searchBeginIndex)
        endIndex = this.uploadData.indexOf("\n", beginIndex + 1)
      } while (beginIndex === -1 || endIndex === -1)
      return this.uploadData.substring(beginIndex, endIndex).trim()
    },
    convertToTreeNode(json, parent) {
      //将json数据转为Node格式
      let node = [];
      for (let key in json) {
        let item = {
          id: this.keyIndex++,
          label: key,
          jsonPath: this.buildJsonPath(parent, json, key)
        }
        if (typeof json[key] == "string" || typeof json[key] == "number") {
          item.label = `${key} : ${json[key]}`
        } else {
          item.children = this.convertToTreeNode(json[key], item)
        }
        node.push(item)
      }
      return node
    },
    buildJsonPath(parent, json, key) {
      //构建jsonPath
      if (parent) {
        if (json instanceof Array) return `${parent.jsonPath}[${key}]`
        return `${parent.jsonPath}.${key}`
      } else {
        if (json instanceof Array) return `$[${key}]`
        return `$.${key}`
      }
    },
    initCanvas() {
      //初始化Canvas尺寸
      let tree = this.$refs.tree
      let treeContainer = this.$refs.treeContainer
      let canvas = this.$refs.canvas
      //设置CSS尺寸
      canvas.style.height = `${parseInt(treeContainer.clientHeight)}px`
      canvas.style.marginTop = `${parseInt(tree.$el.offsetTop)}px`
      //设置分辨率尺寸
      this.canvas_width = parseInt(canvas.clientWidth * window.devicePixelRatio)
      this.canvas_height = parseInt(canvas.clientHeight * window.devicePixelRatio)

      //设置canvas样式
      this.ctx.fillStyle = "#FF0000"
      this.ctx.strokeStyle = "#067969"
      this.ctx.lineWidth = window.devicePixelRatio
    },
    initDrawer() {
      //初始化渲染器
      this.drawer = new MapperDraw(this.mapperInfo, this.cas, this.ctx, this.$refs.treeContainer, this.$refs.table.$el.querySelector("div.el-table__body-wrapper"))
    },
    initTree() {
      let height = document.documentElement.clientHeight;
      let treeTop = this.$refs.treeContainer.getBoundingClientRect().top
      this.$refs.treeContainer.style.height = `${height - treeTop - this.bottomPadding}px`
    },
    addMapper(map) {
      let index = this.mapperInfo.findIndex(item => {
        return item.zEnd.fieldName === map.zEnd.fieldName
      })

      if (index >= 0) {
        this.$message({
          message: '不能在此字段添加新的映射',
          type: 'warning'
        });
        return
      }
      //更新DOM样式
      map.aEnd.dom.classList.add("active")
      map.zEnd.dom.classList.add("field-active")
      //添加映射 可视化渲染
      this.mapperInfo.push(map)
      this.drawer.draw()
    }
  },
  mounted() {
    this.cas = this.$refs.canvas
    this.ctx = this.cas.getContext("2d")
    this.initCanvas()
    this.initTree()
    this.initDrawer()//初始化渲染器
    this.$refs.table.$el.addEventListener("dragover", (e) => {
      e.preventDefault()
    }, false)

    this.$refs.table.$el.addEventListener("drop", (e) => {
        let aEnd = JSON.parse(e.dataTransfer.getData("object"))
        //找到Z端
        let row = e.path.find(node => node.tagName === "TR" && node.classList.contains("el-table__row"))
        this.dragEndNode = row;
        //判断是否已经有映射
        let fieldName = row.querySelector("td").innerText

        let zEnd = {
          fieldName: fieldName,
          offsetY: row.offsetTop
        }

        //添加映射
        this.addMapper({
          aEnd: {
            id: aEnd.id,
            offsetY: aEnd.y,
            jsonPath: aEnd.jsonPath,
            dom: (() => {
              return this.dragNode
            })()
          },
          zEnd: {
            fieldName: zEnd.fieldName,
            offsetY: zEnd.offsetY,
            dom: (() => {
              return this.dragEndNode
            })()
          }
        })
      }
    )
  }
}
</script>


<style>
#stage {
  max-width: 90%;
  margin: auto;
}

#canvas, #upload {
  width: 100%;
  position: relative;
}

#upload {
  margin-top: 15px;
}

.tree-container {
  overflow-y: scroll;
}

.el-col {
  padding: 0 0 0 0 !important;
}

.tree-container div {
  box-sizing: border-box;
}

.active {
  background-color: #28e0a0 !important;
  border-right: 4px solid #067969;
}

.el-tree-node__content {
  height: 26px;
}

.field-active {
  background-color: #4eb5de !important;
}

table {
  border-collapse: collapse;
}

.file-check-state {
  text-align: left;
  padding: 1em 0;
  margin-left: 6em;
}

.not-select {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/data-mapper/mapper.vue